import { serviceHelper } from '../../config/service-helper';
import { AddressValidationClient } from '@jbhi-fi/apis/src/addressValidation';

export function getAddressValidationClient(countryCode?: 'NZ' | 'AU') {
  return new AddressValidationClient({
    url: serviceHelper.addressValidationURL ?? '',
    accessToken: serviceHelper.addressValidationApiKey ?? '',
    isoCountryCode: countryCode ?? (window.Jbhifi?.storeLocation || 'AU'),
  });
}
